// Import our CSS
import 'lazyframe/dist/lazyframe.css';
import 'swiper/css';
import '@/css/app.css';

// Import application behavior.
import '@/ts/scripts';

const revealLazyImage = (image: Element): void => {
    if (!(image instanceof HTMLImageElement) || image.classList.contains('lazy-image-ready')) {
        return;
    }

    // Paint the blurred placeholder before transitioning, even when the full
    // image was served from the browser cache.
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            image.classList.add('lazy-image-ready');
        });
    });
};

document.addEventListener('lazyloaded', (event: Event) => {
    if (event.target instanceof HTMLImageElement && event.target.classList.contains('lazy-image')) {
        revealLazyImage(event.target);
    }
});

document.querySelectorAll<HTMLImageElement>('.lazy-image.lazyloaded').forEach(revealLazyImage);

// Reveal the document only after the imported styles have been evaluated.
requestAnimationFrame(() => {
    document.documentElement.classList.remove('styles-pending');
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR');
    });
}
